import { Box, keyframes, styled } from '@acko-tech/building-blocks.ui.common';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ModalName = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const LastUpdatedDate = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
    margin-top: 4px;
`;

export const StatusText = styled.div<{ background: string; color: string }>`
    margin-top: 14px;
    background: ${(props) => props.background};
    border-radius: 4px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: ${(props) => props.color};
    padding: 6px;
    width: fit-content;
`;

export const PlanDetailsWrapper = styled.div`
    display: flex;
    padding: 12px;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    margin-top: 26px;
    border: 1px solid #e7e7f0;
`;

export const RowWrapper = styled.div`
    display: flex;
    margin-top: 10px;
`;

export const LabelText = styled.div`
    display: flex;
    flex: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const ValueText = styled.div`
    display: flex;
    flex: 1;
    justify-content: flex-end;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    text-align: end;
`;

export const Hr = styled.div`
    width: 100%;
    height: 0px;
    opacity: 0.1;
    border: 1px solid #040222;
    margin-top: 10px;
`;

export const CustomerDetailsWrapper = styled.div`
    display: flex;
    margin-top: 24px;
`;

export const CustomerMobileFlex = styled.div`
    display: flex;
    flex: 2;
    flex-direction: column;
`;

export const CustomerMobileText = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const CustomerMobileNumber = styled.div`
    display: flex;
    margin-top: 6px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
`;

export const CustomerAmountFlex = styled(CustomerMobileFlex)`
    flex: 1;
    align-items: flex-end;
`;

export const ResendLinkWrapper = styled.div`
    display: flex;
    width: 100%;
    margin-top: ${(props) => props.mt || '32px'};
`;

export const ResendLinkText = styled.div`
    display: flex;
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    align-items: center;
    color: #1b73e8;
    justify-content: center;
`;

export const RedirectionLinkText = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const LinkWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
`;

export const LinkContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 8px;
    justify-content: space-between;
`;

export const LinkText = styled.p`
    color: #1b73e8;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    max-width: calc(100% - 10%);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0px;
    padding: 0px;
`;

const Appear = keyframes`
  0%{
    opacity : 0
  }
  50%{
    opacity : 1
  }
  51%{
    opacity : 1
  }
  85%{
    opacity : 0;
    display: none;
  }
  100%{
    opacity : 0;
    display: none;
  }
`;

export const Copied = styled(Box)`
    text-align: center;
    width: max-content;
    box-sizing: border-box;
    background-color: #0fa457;
    color: white;
    padding: 0.5rem;
    border-radius: 8px;
    font-size: 12px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: -100%;
    animation: ${Appear} 1.5s ease-in-out;
`;
